import { DEFAULT_VRAM_KB } from '@/constants/device'
import { useConfigsContext } from '@/context/ConfigsContext'
import { DeviceType } from '@/types/configs'

export const useTotalVramKb = (deviceType: DeviceType) => {
  const { appConfig } = useConfigsContext()

  const deviceToVram = appConfig?.features?.device_to_vram || []
  const totalVramKb =
    deviceToVram?.find((device) => device.device === deviceType)?.top_vram_kb || DEFAULT_VRAM_KB

  return totalVramKb
}
